// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3zBEh","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2Zf-T"};